import React from 'react';
import { Col, Form, FormGroup, Row } from 'reactstrap';
import { InputText, SelectCustom } from '@/components';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks/useForm';
import { OptionProps } from '@/components/Select';
import Bank from '@/model/Bank';
import { FormInputPix } from '../../types';

interface PixContentProps {
  banks: Bank[];
  formData: FormData;
  formErrors: FormErrors;
  onChange: OnChangeFormInput;
}

export const PixContent: React.FC<PixContentProps> = ({
  banks,
  formData,
  formErrors,
  onChange,
}) => {
  const pixTypes: OptionProps[] = [
    {
      value: '0',
      label: 'CPF/CNPJ',
    },
    {
      value: '1',
      label: 'Celular',
    },
    {
      value: '2',
      label: 'E-mail',
    },
    {
      value: '3',
      label: 'Chave aleatória',
    },
  ];
  return (
    <Form
      noValidate={true}
      onSubmit={(e): void => {
        e.preventDefault();
      }}
    >
      <Row>
        <Col md={8}>
          <FormGroup className="mb-2">
            <SelectCustom
              name="bankId"
              label="Instituição"
              placeholder="Selecione ou digite a instituição"
              value={formData[FormInputPix.bankId]}
              onChange={e => onChange(FormInputPix.bankId)(e?.value as string)}
              error={formErrors?.bankId && formErrors.bankId[0]}
              options={banks.map(bank => ({
                label: bank.fullName,
                value: bank.id,
              }))}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <FormGroup className="mb-2">
            <SelectCustom
              name="pixKeyType"
              label="Tipo"
              placeholder="Selecione ou digite o tipo"
              value={formData[FormInputPix.pixKeyType]}
              onChange={e => onChange(FormInputPix.pixKeyType)(e?.value as string)}
              error={formErrors?.pixKeyType && formErrors.pixKeyType[0]}
              options={pixTypes}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <FormGroup className="mb-2">
            <InputText
              name="key"
              label="Pix"
              placeholder="Digite a chave pix"
              value={formData[FormInputPix.key]}
              maxLength={40}
              onChange={e => onChange(FormInputPix.key)(e.target.value)}
              error={formErrors?.key && formErrors.key[0]}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={8}>
          <FormGroup className="mb-2">
            <InputText
              name="recipient"
              label="Beneficiário"
              placeholder="Informe o beneficiário"
              value={formData[FormInputPix.recipient]}
              onChange={e => onChange(FormInputPix.recipient)(e.target.value)}
              error={formErrors?.recipient && formErrors.recipient[0]}
            />
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};
